module.exports = __webpack_public_path__ + "d7c6c504ac18f41125b0ab155cbfcc06.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/App/shared/components/Avatar/images/defaultImage.png
// module id = 1471
// module chunks = 0